import type { Grant } from "./auth";

/**
 * Find a specific grant in a user's grants array by type and id.
 * Returns undefined when grants is undefined (e.g. older API responses that
 * omit the field) or when no matching grant exists.
 * Used by grant-chip UI surfaces to attach hover metadata to each chip.
 */
export const findGrant = (
  grants: Grant[] | undefined,
  type: "cohort" | "project",
  id: string,
): Grant | undefined => grants?.find((g) => g.grant_type === type && g.grant_id === id);
